import { AxiosResponse } from "axios";
import { httpClient } from "./httpClient";
import { TokenResponse } from "../../types/TokenResponse";

const getConfiguration = (accessToken: string) => {
    return {
        headers: { Authorization: `Bearer ${accessToken}` }
    };
}

const getFormConfiguration = (accessToken: string) => {
    return { 
        headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'multipart/form-data',
        }
    };
}

export async function getRequest<T>(path: string, accessToken: string): Promise<T> {
    const response: AxiosResponse<T> = await httpClient.get<T>(path, getConfiguration(accessToken));
    return response.data;
}

export const postAuthorizeCode = async (authenticationCode: string): Promise<TokenResponse> => {
    const response: AxiosResponse<TokenResponse> = await httpClient.post<TokenResponse>(
        `/Authentication/Authorize/${authenticationCode}`
    );

    return response.data;
}

export async function postRequest<T>(path: string, accessToken: string, data: any): Promise<T> {
    const response: AxiosResponse<T> = await httpClient.post<T>(path, data, getConfiguration(accessToken));
    return response.data;
}

export async function postFormRequest<T>(path: string, accessToken: string, data: any): Promise<T> {
    const response: AxiosResponse<T> = await httpClient.post<T>(path, data, getFormConfiguration(accessToken));
    return response.data;
}

export async function deleteRequest<T>(path: string, accessToken: string): Promise<T> {
    const response: AxiosResponse<T> = await httpClient.delete<T>(path, getConfiguration(accessToken));
    return response.data;
}
